export default {"src":"/_next/static/media/Frame 427321056.3494a490.svg","height":352,"width":848,"blurWidth":0,"blurHeight":0};